import { IdNamePair } from "../../customLists/customListView/CustomListView.types.ts";
import { AnnualWheelActivityGeneralType } from "../../annualWheel/annualWheelDialog/AnnualWheelDialog.types.ts";
import { RecurringIntervalType } from "../../annualWheel/AnnualWheel.types.ts";

export interface AnnualWheelActivityStandardTemplateSaveModel {
    id: string;
    notificationPeriodInDays: number | undefined;
    recurringInterval: number | undefined | null;
    recurringIntervalType: RecurringIntervalType | undefined;
    complianceAreaIds: Array<string>;
    languages: AnnualWheelActivityStandardTemplateLanguage[];
    generalType: AnnualWheelActivityGeneralType | undefined;
    customId: string | undefined;
    imageUrl: string | undefined;
}

export interface AnnualWheelActivityStandardTemplateModel {
    id: string;
    notificationPeriodInDays: number | undefined;
    recurringInterval: number | undefined;
    recurringIntervalType: RecurringIntervalType | undefined;
    archived: boolean;
    complianceAreas: Array<IdNamePair>;
    languages: AnnualWheelActivityStandardTemplateLanguage[];
    generalType: AnnualWheelActivityGeneralType | undefined;
    customId: string | undefined;
    imageUrl: string | undefined;
}

export interface AnnualWheelActivityStandardTemplateLanguage {
    name: string | undefined;
    description: string | undefined;
    twoLetterIsoLanguage: string;
    subTasks: string[];
}

export interface AnnualWheelActivityStandardTemplateTableModel extends AnnualWheelActivityStandardTemplateModel {
    name: string | undefined;
    description: string | undefined;
    recurringIntervalString: string;
    complianceAreaString: string;
    statusString: string;
}

export function createNewModel(): AnnualWheelActivityStandardTemplateSaveModel {
    return {
        id: "",
        complianceAreaIds: [],
        notificationPeriodInDays: 14,
        recurringInterval: 12,
        recurringIntervalType: RecurringIntervalType.Month,
        languages: [
            {
                name: "",
                description: "",
                twoLetterIsoLanguage: "da",
                subTasks: [],
            },
            {
                name: "",
                description: "",
                twoLetterIsoLanguage: "en",
                subTasks: [],
            },
        ],
        generalType: undefined,
        customId: undefined,
        imageUrl: undefined,
    };
}
